import styled from "styled-components"

export interface StyledAccordionProps {
}

export const StyledAccordion = styled.div<StyledAccordionProps>`
`
